module.exports = "span {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/messagebox/messagebox.component.scss
// module id = ./src/app/shared/messagebox/messagebox.component.scss
// module chunks = main